//Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";
import { GoogleAnalyticsMixins } from "@/app/mixins/utils/google-analytics-mixins";
import { dateMixins } from "@/app/mixins/utils/date-mixins";
import { inputTextMixins } from "@/app/mixins/utils/input-text-mixins";
import { userMixins } from "@/app/mixins/modules/user-mixins.js";

// Services
import breedService from "@/app/services/main/breed/breed-service.js";
import addressFinderAutocompleteService from "@/app/services/address-finder/address-finder-autocomplete/address-finder-autocomplete-service.js";
import PaymentService from "@/app/services/main/payment/payment-service.js";
import userService from "@/app/services/main/user/user-service.js";

// Util
import { vuelidateUtil } from "@/utils/vuelidate-util.js";

// Third party libraries
import DatePicker from "vue2-datepicker";

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants";
import { GA } from "@/app/constants/ga-constants";
import { STATES } from "@/app/constants/state-constants.js";

export default {
    name: "DogPurchasePublicPage",
    components: {
        DatePicker,
    },
    mixins: [toastMessageMixins, GoogleAnalyticsMixins, dateMixins, inputTextMixins, userMixins],
    data() {
        return {
            isAPILoading: false,
            hasLatitudePay: true,
            breedList: [],
            breedId: "",
            breedSize: "",
            breedName: "",
            gender: "",
            genderOptions: [
                {
                    value: "M",
                    option: "Male",
                },
                {
                    value: "F",
                    option: "Female",
                },
            ],
            colour: "",
            birthdate: null,
            price: null,
            storeCredit: `$${process.env.VUE_APP_STORE_CREDIT.replaceAll(",", "")}`,
            packagePrice: parseInt(process.env.VUE_APP_STORE_CREDIT.replaceAll(",", "")),
            perWeekPrice: 0,
            totalPrice: 0,
            breederId: "",
            breederName: "",
            breederMobile: "",
            breederEmail: "",
            breederList: [],
            breederIdentifier: 0,
            mobileNumberIsValid: true,
            breederMobileNumberIsValid: true,
            addedBreederId: "",
            addedBreedName: "",
            pickupDate: null,

            inputFields: {
                firstName: "",
                surname: "",
                email: "",
                address: "",
                mobileNumber: "",
            },

            // address
            addressList: [],
            isAddressLoading: false,
            selectedPayment: "",
            addressShipping: null,
            isAutoPopulateShipping: false,
            isDefaultAddress: false,

            note: `Additional $${process.env.VUE_APP_STORE_CREDIT} Shop Credit will be charged and can be used for any products`,
            state: "",
            stateOptions: [
                {
                    value: "NSW",
                    name: "New South Wales",
                },
                {
                    value: "VIC",
                    name: "Victoria",
                },
                {
                    value: "QLD",
                    name: "Queensland",
                },
                {
                    value: "WA",
                    name: "Western Australia",
                },
                {
                    value: "SA",
                    name: "South Australia",
                },
                {
                    value: "TAS",
                    name: "Tasmania",
                },
                {
                    value: "NT",
                    name: "Northern Territory",
                },
                {
                    value: "ACT",
                    name: "Australian Capital Territory",
                },
            ],
        };
    },
    mounted() {
        // Send Analytics
        this.sendEventTrackingToGA(
            GA.CHECKOUT_PAGE.ON_PAGE_LOAD.ACTION,
            GA.CHECKOUT_PAGE.CATEGORY,
            GA.CHECKOUT_PAGE.ON_PAGE_LOAD.LABEL
        );

        this.$nextTick(() => {
            this.calculateRepayments();
            this.setUserDetails();
        });
    },
    computed: {
        validationRules() {
            let fields = {
                breederName: {},
                breederMobile: {},
                breederEmail: {},
                breedSize: {},
                price: {},

                inputFields: {
                    firstName: {},
                    surname: {},
                    email: {},
                    address: {},
                },
            };

            fields = vuelidateUtil.setRequiredValidation(fields, "price");

            fields = vuelidateUtil.setRequiredValidation(fields, "breederName");
            fields = vuelidateUtil.setRequiredValidation(fields, "breederMobile");
            fields = vuelidateUtil.setRequiredValidation(fields, "breederEmail");
            fields = vuelidateUtil.setEmailValidation(fields, "breederEmail");

            fields.inputFields.mobileNumber = {};
            fields.inputFields = vuelidateUtil.setFieldsRequired(fields.inputFields, true);
            fields.inputFields = vuelidateUtil.setEmailValidation(fields.inputFields, "email");

            if (parseInt(this.breedId) <= 0) {
                fields = vuelidateUtil.setRequiredValidation(fields, "breedSize");
            }

            return fields;
        },
        selectedGender() {
            let gender = "";

            if (this.gender) {
                gender = this.gender === "M" ? "Male" : "Female";
            } else {
                gender = "Select Gender";
            }

            return gender;
        },
        selectedState() {
            let state = "";

            if (this.state) {
                state = STATES[this.state];
            } else {
                state = "Select State";
            }

            return state;
        },
        isInvalid() {
            return (
                this.gender.length !== 0 &&
                this.breedId !== "" &&
                this.breederName !== "" &&
                this.breederMobile !== "" &&
                !this.breederMobileNumberIsValid
            );
        },
    },
    async created() {
        await this.getBreedList();
        await this.getBreederList();
        this.stateOptions = this.sortAlphabetically(this.stateOptions);
    },
    methods: {
        clearField(field) {
            this[field] = "";
        },
        onSelectedGender(gender) {
            this.gender = gender.value;
        },
        onSelectedState(state) {
            this.state = state.value;
        },
        notAfterToday(date) {
            return date > new Date();
        },
        notBeforeToday(date) {
            return date < new Date();
        },
        onSubmit() {
            this.$v.$touch();

            if (this.$v.$invalid || !this.mobileNumberIsValid || parseFloat(this.price) === 0) {
                return;
            }

            this.isAPILoading = true;

            const address = {
                address: this.addressShipping.address || "N/A",
                addressLine1: this.addressShipping.addressLine1 || "N/A",
                addressLine2: this.addressShipping.addressLine2 || "N/A",
                suburb: this.addressShipping.suburb || "N/A",
                cityTown: this.addressShipping.cityTown || "N/A",
                state: this.addressShipping.state || "N/A",
                postcode: this.addressShipping.postcode || "N/A",
                countryCode: "AU",
            };

            const paymentDetails = {
                dogDetails: {
                    breedId: this.breedId === "" ? 0 : this.breedId,
                    gender: this.gender,
                    colour: this.colour,
                    birthDate: this.birthdate,
                    dogPrice: parseFloat(this.price),
                },
                newBreed: {
                    breedName: this.breedName,
                    breedSize: parseInt(this.breedSize),
                },
                breeder: {
                    breederIdentifier: this.breederIdentifier,
                    breederName: this.breederName,
                    breederId: this.breederId,
                    breederMobile: this.breederMobile.replace("-", ""),
                    breederEmail: this.breederEmail,
                    pickupDate: this.pickupDate,
                    state: this.state,
                },
                customer: {
                    mobileNumber: this.inputFields.mobileNumber.replace("-", ""),
                    firstName: this.inputFields.firstName,
                    surname: this.inputFields.surname,
                    email: this.inputFields.email,
                },
                shippingAddress: address,
                billingAddress: address,
                isDefaultAddress: false
            };

            PaymentService.latitudePaymentPublic(paymentDetails)
                .then((res) => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        const { referenceNumber, token } = res.data;
                        this.$router.push(`/buy-puppy/success?referenceId=${referenceNumber}&token=${token}`);
                    } else {
                        this.showAPIErrorToast("Unable to process your purchase.", res);
                    }
                })
                .catch(() => {
                    this.showGenericErrorToast();
                })
                .finally(() => {
                    this.isAPILoading = false;
                });
        },
        btnYes() {
            this.hasLatitudePay = !this.hasLatitudePay;
            this.$emit("btnYes");
        },
        btnNo() {
            window.open("https://app.uat.latitudepay.com/#sign-up", "_blank");
        },
        onBreederIdBlur() {
            this.$v.breederId.$touch();
        },
        onBreedBlur() {
            this.$v.breedId.$touch();
        },
        createOptionBreed(breed) {
            this.addedBreedName = breed;
            return { name: breed, id: `0-${breed}` };
        },
        createOptionBreeder(breedId) {
            this.addedBreederId = breedId;
            return { code: breedId, name: "", id: `0⁋${breedId}` };
        },
        checkFormat(isBreeder) {
            let mobileNumber = isBreeder
                ? this.breederMobile
                : this.inputFields.mobileNumber;
            let validMobile = isBreeder
                ? this.breederMobileNumberIsValid
                : this.mobileNumberIsValid;
            isBreeder
                ? this.$v.breederMobile.$touch()
                : this.$v.inputFields.mobileNumber.$touch();

            let regexp = /^\d{4}-\d{6}$/;

            if (mobileNumber !== null && mobileNumber !== "") {
                validMobile = regexp.test(mobileNumber);
            } else {
                validMobile = true;
            }
        },
        getBreedList() {
            breedService.getBreeds().then((res) => {
                if (res.status === STATUS_CODES.SUCCESS) {
                    const otherBreedOptions = res.data.data.slice(0, 4);
                    const breeds = this.sortAlphabetically(res.data.data.slice(4, res.data.count));

                    this.breedList = [...otherBreedOptions, ...breeds];
                    this.$store.commit("setBreedLists", this.breedList);
                } else {
                    const { ERROR_GET_BREED_LIST } = this.toastMessages.breed();
                    this.showAPIErrorToast(ERROR_GET_BREED_LIST, res);
                }
            });
        },
        checkOptionID(option) {
            if (typeof option.id === "string") {
                return option.id ? option.id.substring(0, 2) : false;
            }

            return false;
        },
        setSelectedBreeder(e) {
            if (!e) {
                // To trigger the validation
                this.$v.breederName.$touch();
                this.$v.breederMobile.$touch();
                this.$v.breederEmail.$touch();
                this.breederName = "";
                this.breederMobile = "";
                this.breederEmail = "";
                this.state = "";
                return;
            }

            // If add breeder we will check the inputted id is existing in current breeder list
            if (!parseInt(e.id)) {
                const breeder = e.id.split("⁋");
                const breederId = breeder[1];
                const inCurrentBreeder = this.breederList.find((current) => {
                    return (
                        current.code.toLowerCase() === breederId.toLowerCase()
                    );
                });

                if (inCurrentBreeder) {
                    e = inCurrentBreeder;
                }
            }

            this.setBreederInfo(e);
        },
        setBreederInfo(e) {
            if (e) {
                this.breederIdentifier = 0;
                if (e.id && typeof e.id !== "string") {
                    this.breederIdentifier = e.id;
                }

                this.breederId = e.code ? e.code : "";
                this.breederName = e.name ? e.name : "";
                this.breederMobile = e.mobileNumber ? e.mobileNumber.replace(/(....)(......)/g, "$1-$2") : ""; // format mobile number to 0000-000000
                this.breederEmail = e.email ? e.email : "";
                this.state = e.state ? e.state : "";
            }
        },
        setSelected(e) {
            if (!e) {
                // To trigger the validation
                // this.$v.breedId.$touch();
                this.breedId = "";
                return;
            }

            let selectedId = e;

            // If add breed we will check the inputted name if existing in current breed list
            if (!parseInt(e)) {
                const breed = e.split("-");
                const breedName = breed[1];
                const inCurrentBreed = this.breedList.find((item) => {
                    return item.name.toLowerCase() === breedName.toLowerCase();
                });
                if (inCurrentBreed) {
                    selectedId = inCurrentBreed.id;
                } else {
                    selectedId = parseInt(breed[0]);
                }
                this.breedName = breedName;
            }
            this.breedId = selectedId;
        },
        allowOnlyNumbers(e) {
            const invalidChars = ["-", "+", "e", "E"];
            if (invalidChars.includes(e.key)) {
                e.preventDefault();
            }
        },
        formatNumberField(field) {
            if (field < 0) {
                this[field] = 0;
            } 

            if (field === "price") {
                this.$v.price.$touch();
            }
        },
        calculateRepayments() {
            const price = this.price ? parseFloat(this.clearFormatting(this.price)): 0;

            const packagePrice = this.packagePrice;
            this.perWeekPrice = parseInt((price + packagePrice) / 24);
            this.totalPrice = `$${price + parseInt(process.env.VUE_APP_STORE_CREDIT.replaceAll(",", ""))}`;
        },
        clearFormatting(value) {
            if (value) {
                value = value.replace(",", "");
                value = value.replace("$", "");
            }

            return value;
        },

        findBreeder(search, loading) {
            if (search) {
                loading(true);
                this.getBreederList(search, loading);
            } else {
                this.getBreederList(false, loading);
            }
        },
        getBreederList(code, loading) {
            let queryParams = {
                page: 1,
                limit: 20,
                sortBy: "code",
                desc: false,
            };

            if (code) {
                queryParams["f_code"] = code;
            }

            breedService.getBreeders(queryParams).then((res) => {
                if (res.status === STATUS_CODES.SUCCESS) {
                    this.breederList = res.data.data;
                }

                if (loading) {
                    loading(false);
                }
            });
        },
        mobileNumberFormat(value, isBreeder) {
            this.mobileNumberIsValid = true;

            let regexp = /^\d+$/;
            let updateData = regexp.test(value.charAt(value.length - 1));
            const val = value.replace("-", "");

            if (updateData && val.length <= 10) {
                if (isBreeder) {
                    this.breederMobile = val.replace(/(....)(......)/g, "$1-$2");
                } else {
                    this.inputFields.mobileNumber = val.replace(/(....)(......)/g, "$1-$2");
                }
            } else {
                if (isBreeder) {
                    this.breederMobile = !updateData
                        ? val.slice(0, -1)
                        : this.breederMobile;
                } else {
                    this.inputFields.mobileNumber = !updateData
                        ? val.slice(0, -1)
                        : this.inputFields.mobileNumber;
                }
            }
        },
        findAddress(address, type) {
            if (address) {
                if (type === "shipping") {
                    this.isAddressLoading = true;
                } 

                this.delayTyping(() => {
                    this.getAutocompleteAddress(address);
                });
            }
        },
        getAutocompleteAddress(address) {
            addressFinderAutocompleteService
                .getAutocompleteAddress(address)
                .then((res) => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        this.addressList = res.data.completions;
                        this.isAddressLoading = false;
                    } else {
                        const { ERROR_GET_ADDRESS } =
                            this.toastMessages.addressFinder();
                        this.showAPIErrorToast(ERROR_GET_ADDRESS, res);
                        this.isAddressLoading = false;
                    }
                })
                .catch(() => {
                    this.showGenericErrorToast();
                    this.isAddressLoading = false;
                });
        },
        async onBlur(field, type) {
            this.$v.inputFields[field].$touch();

            if (field === "address") {
                if (this.isAutoPopulateShipping) return;
            } 
        },

        async getAddressMetaData(address) {
            this.isAddressLoading = true;
            
            return addressFinderAutocompleteService
                .getAddressMetaData(address.id)
                .then((res) => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        this.isAddressLoading = false;
                        return res.data;
                    } else {
                        const { ERROR_GET_ADDRESS } = this.toastMessages.addressFinder();
                        this.showAPIErrorToast(ERROR_GET_ADDRESS, res);
                        this.isAddressLoading = false;
                    }
                })
                .catch(() => {
                    this.showGenericErrorToast();
                    this.isAddressLoading = false;
                });
        },
        processAddress(address) {
            const updatedAddress = {
                address: address.full_address,
                referenceId: address.id,
                addressLine1: address.address_line_1,
                addressLine2: address.address_line_2,
                suburb: address.locality_name,
                cityTown: address.lga_name,
                state: address.state_territory,
                postcode: address.postcode,
                country: "Australia",
            };

            this.addressShipping = {
                ...updatedAddress,
                addressType: "SHIPPING",
            };
        },
        async setUserDetails() {
            let shipping;
            const { firstName, lastName, emailAddress, id } = this.getUserDetails();

            // verify if user is logged in
            if (id) {
                await userService.getUserAddress().then(async (res) => {
                    if (res.status === 200) {
                        const { shippingAddress } = res.data.addressDetails;
                        shipping = shippingAddress;
                    }
                });

            }

            this.inputFields.firstName = firstName;
            this.inputFields.surname = lastName;
            this.inputFields.email = emailAddress;

            if (shipping && Object.keys(shipping).length > 0) {
                this.inputFields.mobileNumber = shipping.mobileNumber.replace(/(....)(......)/g, "$1-$2");
                this.inputFields.address = shipping.address;
                this.addressShipping = shipping;
            }

            this.isAutoPopulateShipping = true;
        },
        async selectedAddress() {
            if(this.inputFields["address"]){
                const address = await this.getAddressMetaData(this.inputFields["address"]);
                this.processAddress(address);
            }

            this.isAutoPopulateShipping = false;
        },
        redirectBack() {
            this.$router.push("/");
        },
        sortAlphabetically(items) {
            const sortedItems = items.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
            return sortedItems;
        },
    },
    validations() {
        return this.validationRules;
    },
};

